import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M10.982 26.99c-.26 0-.52-.1-.7-.3l-9.97-9.96c-.399-.4-.419-1.06-.04-1.44.38-.38 1.02-.4 1.42 0l9.27 9.3 19.32-19.3c.4-.4 1.019-.4 1.418 0 .4.4.4 1.02 0 1.42l-20.02 20c-.179.18-.439.3-.698.3z" /></svg>;
export default SvgIconCheckmarkOutlined;